import { PracticeRestriction } from 'src/app/shared/models/practiceRestriction';
import { AttentionType } from '../enums/attentionType';

/** Práctica de autocuidado (restriction.patient = 1 en nomenclator). */
export function isPatientPracticeRestriction(
    restriction?: PracticeRestriction | null,
): boolean {
    return !!restriction?.patient;
}

/** Guardia o Autocuidado (Guardia): requiere hora / franja horaria. */
export function isGuardiaLikeRestriction(
    restriction?: PracticeRestriction | null,
): boolean {
    return !!restriction?.requiredTime;
}

/** Visita o Autocuidado (Visita): solo fecha, sin hora obligatoria. */
export function isVisitaLikeRestriction(
    restriction?: PracticeRestriction | null,
): boolean {
    return !restriction?.requiredTime && !restriction?.requiredToDate;
}

/** Práctica contabilizada por horas (guardia y variantes). */
export function isPracticeCountedByHours(
    restriction?: PracticeRestriction | null,
): boolean {
    return !!restriction?.requiredTime || !!restriction?.requiredToDate;
}

/** Atención de autocuidado: restriction.patient (principal) o tipo PRACTICE_MYSELF en schedule (legacy). */
export function isSelfCareAttention(attention?: {
    type?: string;
    practice?: { restriction?: PracticeRestriction };
} | null): boolean {
    if (!attention) {
        return false;
    }
    if (isPatientPracticeRestriction(attention.practice?.restriction)) {
        return true;
    }
    return attention.type === AttentionType.PRACTICE_MYSELF;
}

/** Sub-prestación / práctica del esquema con restriction.patient. */
export function isPatientPracticeProvision(provisionFee?: {
    practice?: { restriction?: PracticeRestriction };
} | null): boolean {
    return isPatientPracticeRestriction(provisionFee?.practice?.restriction);
}
